export default __webpack_public_path__ + "static/media/celikes6.4176ed83.jpg";